import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { exceptionListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useExceptionList from './hooks';
import styles from './ExceptionList.module.scss';

function ExceptionList({ exceptionReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useExceptionList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={exceptionReports}
        headers={exceptionListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

ExceptionList.propTypes = {
  exceptionReports: PropTypes.arrayOf(
    PropTypes.shape({
      exceptionCode: PropTypes.string,
      exceptionCodeAggregator: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

ExceptionList.defaultProps = {
  exceptionReports: [],
  loading: false,
};

export default ExceptionList;
